import React, { useState } from "react";

import { SettingsDrawerButton } from "@components-shared/mobile/settings-drawer";
import { EventBodyTabs } from "@data-types/offer/event/EventViewStoreEnums";
import { EventInsightsSection } from "@features/offer/mobile/shared/event/components/statistics/event-insights/EventInsightsSection";
import {
	LivePlayerStatistics,
	MatchStatistics,
} from "@features/offer/mobile/statistics";
import { OfferStore } from "@state/context/offer/OfferContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import EventViewStore from "@state/stores/offer/event/EventViewStore.mobile";
import { observer } from "mobx-react";

import {
	EmptyStatistics,
	FullStatistics,
	StreaksStatistics,
	TeamStandingsStatistics,
} from "./statistics";
import EventStatisticsHeaderPills from "./statistics/EventStatisticsHeaderPills";
import { TeamLineupsSection } from "./statistics/team-lineups/TeamLineupsSection";

export const EventStatisticsContent = observer(
	function EventStatisticsContent() {
		const store = useOfferContext<OfferStore.EventViewStore>();

		if (store.currentTab === EventBodyTabs.Statistics) {
			return <EventStatistics store={store} />;
		}
		return null;
	}
);

const EventStatistics = observer(function EventStatistics({
	store,
}: {
	store: EventViewStore;
}) {
	const [isSettingsDrawerOpen, setIsSettingsDrawerOpen] =
		useState<boolean>(false);

	const { playerStatisticsStore } = store;

	return (
		<>
			<div className="event__tabs">
				{store.sportStatisticsStore.isStreakStatsActive && (
					<span className="tabs__action">
						<SettingsDrawerButton
							setIsOpen={setIsSettingsDrawerOpen}
							isOpen={isSettingsDrawerOpen}
							buttonClasses="btn btn--square btn--square--sml btn--primary--inverted"
							iconClasses="u-icon--filter"
						/>
					</span>
				)}

				{store.sportStatisticsStore.isMatchStatActive && (
					<span className="tabs__action">
						<SettingsDrawerButton
							buttonClasses="btn btn--square btn--square--sml btn--primary--inverted"
							iconClasses="u-icon--filter"
							setIsOpen={setIsSettingsDrawerOpen}
							isOpen={isSettingsDrawerOpen}
						/>
					</span>
				)}

				{playerStatisticsStore.isPlayerStatActive && (
					<span className="tabs__action">
						<SettingsDrawerButton
							buttonClasses="btn btn--square btn--square--sml btn--primary--inverted"
							iconClasses="u-icon--filter"
							setIsOpen={setIsSettingsDrawerOpen}
							isOpen={isSettingsDrawerOpen}
						/>
					</span>
				)}

				{store.teamStandingsStatsStore.isTeamStandingsStatsActive && (
					<span className="tabs__action">
						<SettingsDrawerButton
							buttonClasses="btn btn--square btn--square--sml btn--primary--inverted"
							iconClasses="u-icon--filter"
							setIsOpen={setIsSettingsDrawerOpen}
							isOpen={isSettingsDrawerOpen}
						/>
					</span>
				)}

				<EventStatisticsHeaderPills store={store} />
			</div>

			{store.displayStatisticsGroup ? (
				<div className="event__statistics">
                    <TeamLineupsSection />
					<StreaksStatistics
						isSettingsDrawerOpen={isSettingsDrawerOpen}
						onClose={() => setIsSettingsDrawerOpen(false)}
					/>
					<MatchStatistics
						isSettingsDrawerOpen={isSettingsDrawerOpen}
						onClose={() => setIsSettingsDrawerOpen(false)}
					/>
					<LivePlayerStatistics
						isSettingsDrawerOpen={isSettingsDrawerOpen}
						onClose={() => setIsSettingsDrawerOpen(false)}
					/>
					<EventInsightsSection />
					<FullStatistics />
					<TeamStandingsStatistics
						isSettingsDrawerOpen={isSettingsDrawerOpen}
						onClose={() => setIsSettingsDrawerOpen(false)}
					/>
				</div>
			) : (
				<EmptyStatistics />
			)}
		</>
	);
});
